export default "__VITE_PUBLIC_ASSET__9c3acfa1__"